import { Island } from '../../../islands/island.class';
import { ReferenceMap } from '../../../shared.types';

type IsIslandVentingRequiredParams = {
	island: Island;
	refMap: ReferenceMap;
	excludeItemRefs?: Array<string>;
};

export const isIslandVentingRequired = ({ island }: IsIslandVentingRequiredParams): boolean => {
	if (!island?.panels?.children) return false;

	let ventsRequired = false;

	island.panels.children.forEach((panel) => {
		panel.panelItemGroups.children.forEach((group) => {
			// eslint-disable-next-line consistent-return
			group.items.children.forEach((panelItem) => {
				// A custom (override) grill or burner never has `fuel: true` -- the Add Custom Appliance
				// panel does not set it -- so fall back to the category. Grills and Side Burners are the
				// two categories that carry `RequiresVenting` in category.data.ts, and `isGrillOrSideBurner`
				// already encodes that pair for other rules (combustible clearance, sleeve pairing).
				const ventsNeededForItem = panelItem.item.fuel || (panelItem.item.category?.isGrillOrSideBurner ?? false);
				if (ventsNeededForItem) {
					ventsRequired = true;
					return ventsRequired;
				}
			})
		})
	})
	return ventsRequired;
};
